<template>
  <div class="wf-latest-articles">
    <div v-if="latestArticles.MainArticle" class="wf-latest-articles-main">
      <pc-responsive-image
        :desktopSrc="latestArticles.MainArticle.FeatureImageDesktop"
        :mobileSrc="latestArticles.MainArticle.FeatureImageMobile"
        :imageAlt="latestArticles.MainArticle.FeatureImageAltText"
        :imageCss="'background-image object-position-center'"
      ></pc-responsive-image>
      <div class="container-fluid">
        <div class="wf-latest-articles-main-content">
          <div class="secondary-heading">
            {{ latestArticles.MainArticle.Category }}
          </div>
          <h3>
            {{ latestArticles.MainArticle.Title }}
          </h3>
          <div class="wf-article-date">
            {{ latestArticles.MainArticle.Date }}
          </div>
          <div class="mb-2" v-html="latestArticles.MainArticle.Summary"></div>
          <div class="wf-latest-articles-main-buttons">
            <div
              v-if="latestArticles.MainArticle.Type == 'Videos'"
              class="vue-wf-video-modal-button"
            >
              <wf-video-modal-button
                css-class="call-to-action-button btn btn-white border-dark"
                video-type="element"
                video-data="@Model.MainArticle.Media1"
              >
                Watch now
                <span
                  :class="'png-icon png-icon-icons-glyph--k-play-fill'"
                ></span>
              </wf-video-modal-button>
            </div>
            <pc-call-to-action-button
              :title="'View article'"
              :url="latestArticles.MainArticle.Url"
              :reverseColors="true"
            ></pc-call-to-action-button>
          </div>
        </div>
      </div>
    </div>
    <div class="wf-latest-articles-additional">
      <div class="wf-latest-articles-title">
        <h2 class="h3 m-0">
          {{ latestArticles.Title }}
        </h2>
      </div>

      <div
        v-for="(article, index) in latestArticles.AdditionalArticles"
        :key="'latest-article' + index"
        class="wf-latest-articles-additional-item"
      >
        <div class="wf-latest-articles-additional-image">
          <img
            :class="article.CssClasses"
            class="image"
            :src="article.TeaserImage"
            :alt="article.TeaserImageAltText"
          />
        </div>
        <div class="wf-latest-articles-additional-content">
          <div class="secondary-heading">
            {{ article.Category }}
          </div>
          <h3>
            {{ article.Title }}
          </h3>
          <div class="wf-article-date">
            {{ article.Date }}
          </div>
          <div class="mb-2" v-html="article.Summary"></div>
          <div class="wf-latest-articles-main-buttons">
            <div
              v-if="article.Type == 'Videos'"
              class="vue-wf-video-modal-button"
            >
              <wf-video-modal-button
                css-class="call-to-action-button btn btn-white border-dark"
                video-type="element"
                :video-data="article.Media1"
              >
                Watch now
                <span
                  :class="'png-icon png-icon-icons-glyph--k-play-fill'"
                ></span>
              </wf-video-modal-button>
            </div>
            <pc-call-to-action-button
              :url="article.Url"
              :reverseColors="true"
              :title="'View Article'"
            ></pc-call-to-action-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PcResponsiveImage from "./../common/pc-responsive-image.vue";
import WfVideoModalButton from "./../wf-video-modal-button.vue";
import PcCallToActionButton from "../common/pc-call-to-action-button.vue";
export default {
  props: ["latestArticles"],
  components: {
    PcResponsiveImage,
    WfVideoModalButton,
    PcCallToActionButton
  }
};
</script>
